<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Link:</label>
        <div>
          <input type="text" placeholder="Link" v-model="editLink" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Name:</label>
        <div>
          <input type="text" placeholder="Name" v-model="editName" />
        </div>
      </div>
      <div class="form-inline flex-row m-t-l">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >Add Link</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["submitLoading"],
  data() {
    return {
      editName: null,
      editLink: null,
    };
  },
  components: {
    spinnerButton,
  },
  methods: {
    buttonClick: function () {
      if (!this.editLink) {
        this.$toasted.global.toast_error({ message: "please input link" });
        return;
      }
      this.$emit("buttonClick", this.editName, this.editLink);
    },
  },
};
</script>
